<script lang="ts">
  import { isNonEmptyArray } from '#app/lib/boolean_tests'
  import { hasTruthy } from '#app/lib/utils'
  import { getEntitiesAttributesByUris, type SerializedEntitiesByUris } from '#entities/lib/entities'
  import { getBestLangValue } from '#entities/lib/get_best_lang_value'
  import Spinner from '#general/components/spinner.svelte'
  import type { EntityUri } from '#server/types/entity'
  import { getCurrentLang } from '#user/lib/i18n'

  const {
    entitiesUris = [],
  }: {
    entitiesUris: EntityUri[]
  } = $props()

  let entitiesByUris: SerializedEntitiesByUris = $state()
  const firstAuthorsLimit = 5
  const firstAuthorsUris = $derived(entitiesUris.slice(0, firstAuthorsLimit))

  const waitingForAuthors = getAuthors()
  async function getAuthors () {
    if (isNonEmptyArray(entitiesUris)) {
      const attributes = [ 'labels' ] as const
      ;({ entities: entitiesByUris } = await getEntitiesAttributesByUris({ uris: entitiesUris, attributes }))
    }
  }

  function getBestLabel (claimValue) {
    const bestValue = getBestLangValue(getCurrentLang(), null, entitiesByUris[claimValue].labels)
    if (hasTruthy(bestValue, 'value')) return bestValue.value
  }
</script>

{#await waitingForAuthors}
  <Spinner />
{:then}
  {#if entitiesByUris && isNonEmptyArray(entitiesUris)}
    <p class="authors-labels">
      {firstAuthorsUris.map(getBestLabel).join(', ')}
      {#if firstAuthorsLimit < entitiesUris.length}
        ...
      {/if}
    </p>
  {/if}
{/await}

<style lang="scss">
  @import "general/scss/utils";
  .authors-labels{
    color: $grey;
    font-size: 0.9rem;
    margin-block-end: 0.1em;
  }
</style>
